/**
* @file 业务设置-敏感人员数据
* */
<template>
  <div id="basic">
    <div class="blueInfo">
      <p>*添加的身份证号码或手机号码下单时，系统都将发出预警<br />
        *黑名单用户的身份证号码、手机号码将无法下单</p>
    </div>

    <div class="operate">
      <el-select v-if="mixinUserInfo && mixinUserInfo.organizationType == 1" v-model="search.organizationId" @change="getTable" filterable clearable>
        <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
        </el-option>
      </el-select>
      <div v-else></div>

      <el-button class="add" type="primary" @click="dialogShow=true">添加</el-button>
    </div>

    <el-table :data="tableData" border style="width: 820px">
      <el-table-column v-if="mixinUserInfo &&mixinUserInfo.organizationType === 1" prop="organizationName" label="机构名称"></el-table-column>
      <el-table-column prop="idCard" label="身份证号码">
        <template slot-scope="scope">
          <span @dblclick="$utils.dblclickCopy">{{scope.row.idCard}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="phone" label="手机号码">
        <template slot-scope="scope">
          <span @dblclick="$utils.dblclickCopy">{{scope.row.phone}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="idCard" label="黑名单">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" @change="statusChange($event, scope.row)" :active-value="1" :inactive-value="2"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="text" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="添加数据" :visible.sync="dialogShow" @close="dialogClose" width="500px" top="30vh" center>
      <div class="form">
        <div><span>*</span>身份证号码</div>
        <el-input v-model="idCard" placeholder="15位-18位字符" :maxlength="20"></el-input>
      </div>
      <div class="form">
        <div><span>*</span>手机号码</div>
        <el-input v-model="phone" placeholder="固定11位数字" :maxlength="15"></el-input>
      </div>
      <div class="form">
        <div><span>*</span>机构名称</div>
        <el-select v-model="organizationId" @change="getTable" :disabled="!mixinUserInfo || mixinUserInfo.organizationType != 1" filterable clearable>
          <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
          </el-option>
        </el-select>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="save" :loading="saveStatus" style="width:100%">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "basic",
  data() {
    return {
      search: { organizationId: null },
      tableData: [],
      dialogShow: false,
      idCard: null,
      phone: null,
      organizationId: null,
      saveStatus: false, // 保存按钮loading
    };
  },
  watch: {
    'search.organizationId'(val) {
      this.getTable();
    }
  },
  created() {
    if (this.mixinUserInfo.organizationType != 1) {
      this.organizationId = this.mixinUserInfo.organizationId;
    }
    this.mixinOrganizations();
    this.getTable();
  },
  methods: {
    async getTable() {
      let url = '/api/v1/manage/sensitive/personnel';
      let data = await this.$axios.get(url, {
        organizationId: this.search.organizationId
      });
      if (data && data.code === 1) {
        this.tableData = data.data;
      }
    },

    /* 模态框关闭 */
    dialogClose() {
      this.idCard = null;
      this.phone = null;
      this.organizationId = this.mixinUserInfo.organizationType == 1 ? null : this.mixinUserInfo.organizationId;
    },

    /* 保存 */
    async save() {
      if (!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(this.idCard)) {
        this.$message.info("请输入正确的身份证号码");
        return;
      } else if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.phone)) {
        this.$message.info("请输入正确的手机号码");
        return;
      }

      this.saveStatus = true;
      let url = '/api/v1/manage/sensitive/personnel';
      let data = await this.$axios.post(url,
        {
          idCard: this.idCard,
          phone: this.phone,
          organizationId: this.organizationId,
          status: 2,
        }
      );
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.getTable();
        this.dialogShow = false;
      }
      this.saveStatus = false;
    },

    // 黑名单状态更改
    async statusChange(status, row) {
      let url = "/api/v1/manage/sensitive/personnel";
      let params = {
        id: row.id,
        idCard: row.idCard,
        phone: row.phone,
        status: status,
      };
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success(status == 1 ? '用户已加入黑名单' : '用户已解除黑名单')
        this.getTable();
      } else {
        row.status = status == 0 ? 1 : 0;
      }
    },

    /* 删除 */
    async remove(row) {
      let url = '/api/v1/manage/sensitive/personnel';
      let data = await this.$axios.delete(url, { id: row.id });
      if (data && data.code === 1) {
        this.$message.info("已删除");
        this.getTable();
      }
    }
  },
};
</script>

<style lang="less">
#basic {
  .blueInfo {
    width: 800px;
    display: flex;
    align-content: center;
    justify-content: space-between;
    p {
      line-height: 2;
    }
  }

  .operate {
    width: 820px;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
  }

  .form {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div:nth-child(1) {
      width: 100px;
      flex-shrink: 0;
      span {
        margin-right: 5px;
        color: red;
      }
    }
  }
}
</style>
